/**
 * Attendance API Contracts
 *
 * The operator-facing attendance surfaces under /v1/schools/:id. The submission
 * paths themselves live in `api/students` (parent-reported absence) and
 * `api/sections` (faculty write); this entry carries what is READ BACK about
 * them.
 */

// The attempt ENTITY travels with this contract — a consumer of the endpoint
// needs the record shape, and re-exporting here means neither side has to
// import from two subpaths to read one response.
export * from '../../schemas/entities/attendance-attempt'
export * from './attempts'
